module.exports = __webpack_public_path__ + "img/flags/TJ.b2303cc.png";